export const loadSettingsView = () => import("./views/settings.view");
